import { Message } from '../entities/message';

export { Message }

export class Ticket {
    public TicketId: number;
    public Fullname: string;
    public ChampionshipId: number;
    public LoginId: number;
    public CreatedDateString: string;
    public Status: number;
    public Payed:  boolean;
    public Messages: Message[];
}


// WEBPACK FOOTER //
// ./src/entities/ticket.ts